module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_2000_3000.08d0e5a7.png";